module.exports = __webpack_public_path__ + "img/about-in-app.54a455fa.svg";